@if (displayed) {
  <div class="global-banner-container {{ severity }}">
    <div class="global-banner-text">
      <mat-icon>{{ icon }}</mat-icon>
      <span>
        {{ text }}
        @if (linkText) {
          <a
            [routerLink]="routerLink"
            >{{ linkText }}</a
            >
          }
        </span>
      </div>
      <button
        mat-button
        class="dismiss-button {{ severity }}"
        (click)="onDismiss()"
        [color]="'green'"
        >
        DISMISS
      </button>
    </div>
  }
